<mibi-single-center-card-layout
    *ngIf="tokenValid; else invalidToken"
    cardTitle="E-Mail-Adresse bestätigt"
>
    <mibi-box-layout mibi-card-content>
        <p>Sie haben Ihre E-Mail-Adresse bestätigt.</p>
        <p class="mibi-last">
            Sobald der {{ appName }} Administrator Ihr Konto freigeschaltet hat,
            erhalten Sie eine Benachrichtigung und können sich einloggen.
        </p>
    </mibi-box-layout>
</mibi-single-center-card-layout>

<ng-template #invalidToken>
    <mibi-single-center-card-layout cardTitle="Fehler">
        <mibi-box-layout mibi-card-content>
            <p>Die Bestätigung Ihrer E-Mail-Adresse ist fehlgeschlagen.</p>
            <p class="mibi-last">Bitte erneut registrieren.</p>
        </mibi-box-layout>
        <a mibiCardActions mat-button color="primary" [routerLink]="[userLinks.register]">
            Weiter zur Registrierung
        </a>
    </mibi-single-center-card-layout>
</ng-template>
